<template>
  <v-row class="mt-5">
    <v-col cols="6" md="" sm="4">
      <v-card @click="onRedirect('unresolved')"  class="card-metrics"
       v-track="'redirect-to-resolved-tickets'">
        <v-card-title class="body-1 text-capitalize">
          <span> Unresolved Tickets</span>
          <v-tooltip top max-width="350px" color="rgba(0, 0, 0, 0.7)">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                size="20"
                class="pl-2 cursor-pointer"
                id="Unresolved-tickets-info"
                >mdi-information-outline</v-icon
              >
            </template>
            <span>
              All tickets in the system that are currently not marked as resolved.
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="text-h2" v-show="loading">
          <span class="secondary--font font-weight-regular pink-color">
            {{ unresolvedTickets }}
          </span>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" md="" sm="4">
      <v-card @click="onRedirect('open')" class="card-metrics"
       v-track="'redirect-to-open-tickets'">
        <v-card-title class="body-1 text-capitalize">
          <span> Open tickets</span>
          <v-tooltip top max-width="350px" color="rgba(0, 0, 0, 0.7)">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                size="20"
                class="pl-2 cursor-pointer"
                id="open-tickets-info"
                >mdi-information-outline</v-icon
              >
            </template>
            <span>
              Tickets assigned to agents and requiring action.
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="text-h2" v-show="loading">
          <span class="secondary--font font-weight-regular light-blue-color">
            {{ openTickets }}
          </span>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="6" md="" sm="4">
      <v-card @click="onRedirect('pending_on_hold')" class="card-metrics"
       v-track="'redirect-to-pending-on-hold-tickets'">
        <v-card-title class="body-1 text-capitalize">
          <span> Pending & on-hold tickets</span>
          <v-tooltip top max-width="350px" color="rgba(0, 0, 0, 0.7)">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                size="20"
                class="pl-2 cursor-pointer"
                id="pending-onhold-tickets-info"
                >mdi-information-outline</v-icon
              >
            </template>
            <span>
              Tickets assigned to agents are requiring further information or are otherwise blocked.
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="text-h2" v-show="loading">
          <span class="secondary--font font-weight-regular dark-blue-color">
            {{ pendingOnhold }}
          </span>
        </v-card-text></v-card
      >
    </v-col>
    <!-- <v-col cols="6" md="" sm="4">
      <v-card class="card-metrics">
        <v-card-title class="body-1"> Unassigned tickets </v-card-title>
        <v-card-text class="text-h2">
          <span class="secondary--font font-weight-regular green-color">
            05
          </span>
        </v-card-text></v-card
      >
    </v-col> -->
    <v-col cols="6" md="" sm="4">
      <v-card  @click="onRedirect('new')" class="card-metrics" 
       v-track="'redirect-to-new-tickets'">
        <v-card-title class="body-1 text-capitalize">
          <span> New tickets</span>
          <v-tooltip top max-width="350px" color="rgba(0, 0, 0, 0.7)">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                size="20"
                class="pl-2 cursor-pointer"
                id="new-tickets-info"
                >mdi-information-outline</v-icon
              >
            </template>
            <span>
              Tickets that are unresolved and unassigned.
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="text-h2" v-show="loading">
          <span class="secondary--font font-weight-regular black-color">
            {{ newTickets }}
          </span>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { $dashboard } from "@/services/Index";
export default {
  name: "current-metrices",
  data() {
    return {
      loading: false,
      unresolvedTickets: 0,
      openTickets: 0,
      pendingOnhold: 0,
      newTickets: 0,
    };
  },
  mounted() {
    this.getMetricesData();
  },
  methods: {
    /** get Metrices data from API's */
    async getMetricesData() {
      this.loading = false;

      await $dashboard
        .currentMetrices({})
        .then((response) => {
          this.unresolvedTickets = response.data.unresolved
            ? response.data.unresolved
            : 0;
          this.openTickets = response.data.open ? response.data.open : 0;
          this.pendingOnhold =
            (response.data.pending ? response.data.pending : 0) +
            (response.data.on_hold ? response.data.on_hold : 0);
          this.newTickets = response.data.new ? response.data.new : 0;
          this.loading = true;
        })
        .catch(() => {
          this.loading = true;
        });
    },
    onRedirect(filterValue){
      this.$router.push({
        name: 'tickets',
        query: {'status' : filterValue},
      });
    }
  },
};
</script>

<style scoped>
.card-metrics {
  min-height: 190px;
}
</style>
